<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import BaseModal from '@/components/BaseModal.vue'
import { confirmState, resolveConfirm } from '@/composables/useConfirm'

// Mounted once (App.vue). Renders the shared confirm state as a proper modal,
// replacing the browser's native confirm() dialog everywhere.
const { t } = useI18n()
</script>

<template>
  <BaseModal :show="confirmState.open" size="small" :z-index="2000" @close="resolveConfirm(false)">
    <template #header>
      <h2 style="display:flex;align-items:center;gap:10px;">
        <span
          class="shrink-0"
          :style="{ width:'34px', height:'34px', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', background: confirmState.danger ? '#fee2e2' : '#f3f4f6' }"
        >
          <svg v-if="confirmState.danger" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
          <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#374151" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
        </span>
        {{ confirmState.title || (t('common.confirmTitle') || 'Bestätigen') }}
      </h2>
      <button type="button" class="btn-close" @click="resolveConfirm(false)">×</button>
    </template>

    <p style="margin:0;font-size:14px;color:#374151;line-height:1.55;white-space:pre-line;">{{ confirmState.message }}</p>

    <template #footer>
      <button type="button" class="cd-btn cd-btn-secondary" @click="resolveConfirm(false)">
        {{ confirmState.cancelText || (t('common.cancel') || 'Abbrechen') }}
      </button>
      <button
        type="button"
        class="cd-btn"
        :class="confirmState.danger ? 'cd-btn-danger' : 'cd-btn-primary'"
        @click="resolveConfirm(true)"
      >
        {{ confirmState.confirmText || (t('common.confirm') || 'Bestätigen') }}
      </button>
    </template>
  </BaseModal>
</template>

<style scoped>
.cd-btn {
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 0.15s, border-color 0.15s;
}
.cd-btn-secondary {
  background: #fff;
  color: #374151;
  border-color: #d1d5db;
}
.cd-btn-secondary:hover { background: #f9fafb; }
.cd-btn-danger {
  background: #dc2626;
  color: #fff;
}
.cd-btn-danger:hover { background: #b91c1c; }
.cd-btn-primary {
  background: #1f2937;
  color: #fff;
}
.cd-btn-primary:hover { background: #111827; }
</style>
